export var Middleware;
(function (Middleware) {
    function apply(middleware, factory) {
        return opt => middleware(factory(opt))(opt);
    }
    Middleware.apply = apply;
    function compose(...middlewares) {
        return middlewares.reduce((outer, inner) => next => opt => outer(inner(next)(opt))(opt));
    }
    Middleware.compose = compose;
})(Middleware || (Middleware = {}));
//# sourceMappingURL=middleware.js.map